import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";

import { Icon, ModalService } from "@sportal/cdk";

import { MobileModalListItem } from "../../../../../settings/tabs/devicesTab/tableComponents";
import { ConfirmationDialog } from "../../../../../../components";
import { PlainButton } from "../../../../../../components/plainButton/PlainButton";
import { removeScheduleRule } from "../../../../../../store/schedules";

export const RemoveScheduleModal = ({ modal }) => (
  <ConfirmationDialog
    className="remove-schedule-dialog"
    modal={modal}
    content={<FormattedMessage id="remove_schedule_rule_message" />}
    cancelMessage={<FormattedMessage id="cancel" />}
    submitMessage={<FormattedMessage id="delete" />}
  />
);

export const useRemoveSchedule = (schedule) => {
  const dispatch = useDispatch();

  const remove = () => {
    ModalService.show((modal) => ({
      dialog: <RemoveScheduleModal modal={modal} />,
    }))
      .then(() => {
        dispatch(removeScheduleRule(schedule));
      })
      .catch(() => {});
  };

  return {
    content: <FormattedMessage id="delete" />,
    icon: "fa-regular fa-trash",
    action: remove,
    id: "remove-schedule",
  };
};
export const RemoveScheduleModalItem = ({ schedule }) => {
  const { content, action, id, icon } = useRemoveSchedule(schedule);

  return (
    <MobileModalListItem
      content={content}
      action={action}
      id={id}
      icon={icon}
    />
  );
};

export const RemoveScheduleButton = ({ schedule, className }) => {
  const { content, action, id, icon } = useRemoveSchedule(schedule);

  return (
    <PlainButton className={className} onClick={action} id={id}>
      <Icon icon={icon} />
      {content}
    </PlainButton>
  );
};
